export default __webpack_public_path__ + "static/media/teamMembers.b698862a.svg";